<template>
    <div>
        <div class="_dflex-block animate__parent">
            <!-- Left part -->
            <div class="_w-384 _mt-48-24" >
                <section v-sticky.desktop>
                    <press-switcher></press-switcher>

                    <div class="_mt-32-24">
                        <press-search placeholder="Поиск"></press-search>
                    </div>

                    <div class="_mt-32-24">
                        <press-calendar></press-calendar>
                    </div>

                    <div class="_mt-32-24">
                        <press-tags :items-mobile="mobileLinks" :items="tags"></press-tags>
                    </div>

                    <div class="press-contacts _mobile-hidden">
                        <p class="p2 gray-text-light">Телефон пресс-службы</p>
                        <div class="_mt-8">
                            <ui-copier>
                                <div class="h4">+7 495 775-86-86</div>
                            </ui-copier>
                        </div>

                        <p class="p2 gray-text-light _mt-16">Электронная почта</p>
                        <div class="_mt-8">
                            <ui-copier up>
                                <div class="h4">prbank@domrf.ru</div>
                            </ui-copier>
                        </div>
                    </div>

                    <div class="press-tg _mobile-hidden">
                        <img src="/local/templates/redesign/src/assets/img/press/qr.webp" class="_w-76" />
                        <div class="_ml-24">
                            <p class="p1">Новости в Telegram</p>
                            <div class="_mt-18">
                                <DButton color="black" size="small" @click="openLink('https://t.me/domrf_bank')">Присоединиться</DButton>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <!-- Right part -->
            <section class="_ml-32-0 _mt-48-32">
                <preloader v-show="loading"></preloader>
                <press-news :items="items"></press-news>

                <div class="press-contacts _mobile-visible">
                    <p class="p2 gray-text-light">Телефон пресс-службы</p>
                    <div class="_mt-8">
                        <ui-copier>
                            <div class="h4">+7 495 775-86-86</div>
                        </ui-copier>
                    </div>
                    <p class="p2 gray-text-light _mt-24">Электронная почта</p>
                    <div class="_mt-8">
                        <ui-copier>
                            <div class="h4">prbank@domrf.ru</div>
                        </ui-copier>
                    </div>
                </div>

                <div class="press-tg _mobile-visible _mb-24-24">
                    <p class="p1">Присоединяйтесь к нашему Telegram-каналу</p>
                    <div class="_mt-8">
                        <ui-copier up>
                            <div class="p2 h4">https://t.me/domrf_bank</div>
                        </ui-copier>
                    </div>
                    <a href="https://t.me/domrf_bank" class="button button_black _mt-24">Открыть</a>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import { ref, watch, computed } from 'vue';
    import { useStore } from '../../store';
    import { DButton } from '@ahml/domrfbank-ui/elements/DButton';
    import pressSwitcher from './pressSwitcher.vue';
    import pressSearch from './pressSearch.vue';
    import pressCalendar from './pressCalendar.vue';
    import pressTags from './pressTags.vue';
    import pressNews from './pressNews.vue';
    import UiCopier from '../ui/UiCopier.vue';

    export default {
        name: "pressPage",
        props: {
            items: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        components: {
            DButton,
            pressSwitcher,
            pressSearch,
            pressCalendar,
            pressTags,
            pressNews,
            UiCopier,
        },
        setup(props) {
            let loading = ref(false);
            let tags = [];
            const mobileLinks = props.items.map((val) => {
                return { title: val.name, const: val.code }
            });
            const store = useStore();

            tags = props.items.filter(val => val.code !== 'all');
            mobileLinks.unshift( {const: "", title: "Все новости"} );

            let stateLoading = computed(() => {
                return store.state.press.loading;
            });

            watch(stateLoading , (val) => {
                loading.value = val;
            });

            return {
                mobileLinks,
                tags,
                loading
            };
        },
        methods: {
            openLink(link) {
                window.location.href = link;
            }
        },
    }
</script>
